import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepAppsureBankDetails = (state) => state.get('stepAppsureBankDetails');

const makeSelectStepAppsureBankDetails = () =>
  createSelector(selectStepAppsureBankDetails, (stepAppsureBankDetailsState) => ({
    abn: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'abn']),
      ''
    ),
    claimITC: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'claimITC']),
      ''
    ),
    nameOfBank: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'nameOfBank']),
      ''
    ),
    branch: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'branch']),
      ''
    ),
    bsbNumber: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bsbNumber']),
      ''
    ),
    accountNumber: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'accountNumber']),
      ''
    ),
    accountHolder: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'accountHolder']),
      ''
    ),
    registerForGSTPurpose: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'registerForGSTPurpose']),
      ''
    ),
    percentageOfGST: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'percentageOfGST']),
      ''
    ),
    bsbCannotBeVerified: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bsbCannotBeVerified']),
      ''
    ),
    isBsbValid: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'isBsbValid']),
      ''
    ),
    otherInsurance: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'otherInsurance']),
      ''
    ),
    provideDetails: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'provideDetails']),
      ''
    ),
  }));

const makeSelectStepAppsureBankDetailsErrors = () =>
  createSelector(selectStepAppsureBankDetails, (stepAppsureBankDetailsState) =>
    mapWithDefault(stepAppsureBankDetailsState, () => stepAppsureBankDetailsState.get('currentStep'), [])
  );

const makeSelectBsbValidating = () =>
  createSelector(selectStepAppsureBankDetails, (stepAppsureBankDetailsState) =>
    mapWithDefault(stepAppsureBankDetailsState, () => stepAppsureBankDetailsState.get('bsbValidating'), false)
  );

const makeSelectBsbNotice = () =>
  createSelector(selectStepAppsureBankDetails, (stepAppsureBankDetailsState) =>
    mapWithDefault(stepAppsureBankDetailsState, () => stepAppsureBankDetailsState.get('showBSBNotice'), false)
  );

export {
  makeSelectStepAppsureBankDetails,
  makeSelectStepAppsureBankDetailsErrors,
  makeSelectBsbValidating,
  makeSelectBsbNotice,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/selectors.js